module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAASCAYAAABWzo5XAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAADHSURBVHgBpZRhEYMwDIVzU1AJlTAJk4CD4WQ4YA6Yg0lAChKQkCV3j1tuC20K7+79KeTra0oggpg5iTOdkQDu4pW/msU9tUqKFvFTE4lv4hfWljAQxaqrsz40AXGsrrBRDIieTFRPXgaiL5oqUT39BlwRIHmpBgoKQE32/n3Q6S7UIJxElS5mPcHnhJhTw/v5r0ZvABFzAKCj9HCbrQ0LXL8F7F5/6YOsA8xZvRGJAZxEoxnasQlgQD2KNs185DdigJkDY+LpAwAcenmTG9OrAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/submit.png
// module id = tUGb
// module chunks = 1